import { render } from "./ProductSection.vue?vue&type=template&id=d1946842&scoped=true"
import script from "./ProductSection.vue?vue&type=script&lang=js"
export * from "./ProductSection.vue?vue&type=script&lang=js"

import "./ProductSection.vue?vue&type=style&index=0&id=d1946842&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1946842"]])

export default __exports__